import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import PropertyCard from './child-components/PropertyCard';

const PropertyList = ({ className, items }) => {
    const restorationRef = useRef(null);
    const history = useHistory();
    const [idMarker, setIdMarker] = useState(0);

    useEffect(() => {
        // History action will be POP when a user is "moving back" to a page. Alternative will be "PUSH"
        if (history.action !== 'POP') {
            return null;
        }

        // Reading in a callback to ensure we only query sessionStorage once, even after a re-render
        const persistedId = sessionStorage.getItem('scroll-position-id-marker');

        sessionStorage.removeItem('scroll-position-id-marker');

        setIdMarker(persistedId || null);

        return null;
    }, [history.action]);

    const persistScrollPosition = (id) => {
        // Use sessionStorage in place of global state management
        sessionStorage.setItem('scroll-position-id-marker', id);
    };

    return (
        <div className={className}>
            {items &&
                items.map((item) => (
                    <div
                        key={`property-${item.id}`}
                        className="property-list-card"
                    >
                        <PropertyCard
                            {...item}
                            onClickHandler={persistScrollPosition}
                            restorationRef={
                                Number(idMarker) === item.id
                                    ? restorationRef
                                    : null
                            }
                        />
                    </div>
                ))}
        </div>
    );
};

export default PropertyList;
